<h1 mat-dialog-title></h1>
<div mat-dialog-content>
    <p>{{data.message}}</p>
    <a *ngIf="data.hasLink" href="{{data.URL}}" target="_blank">{{data.goToLink}}</a>
</div>
<hr/>
<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close(false)" style="color: #007ad9;">Close</button>
</div>